module.exports = "<p>\n  Profiles Works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profiles/profiles.component.html
// module id = 608
// module chunks = 1